var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVideoOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .video_off_a {\n                fill: #fff;\n            }\n\n            .video_off_b {\n                fill: none !important;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-286.575 -380.813)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "video_off_a",
    d: "M307.156,391.631v3.52l8,7.46V389.4l-5.333,5.948v-5.2a1.419,1.419,0,0,0-1.333-1.489h-8.21l3.174,2.972Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "video_off_a",
    d: "M291.478,383.812l-2.075,2.167,2.841,2.719a1.42,1.42,0,0,0-1.088,1.448v14.865a1.42,1.42,0,0,0,1.334,1.487h16a1.413,1.413,0,0,0,1.273-1.027l3.911,3.744,2.074-2.166Zm15.678,19.714H293.823V391.631h1.484l11.849,11.344Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "video_off_b",
    d: "M0,0H32V32H0Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVideoOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_video_off.9beabecc63d0940a440490f1bcb0ee69.svg";